<template>
  <v-card
    dark
    class="primary darken-1"
    height="327"
    :min-width="minWidth"
    :width="width"
    style="border-radius: 5px; overflow-y: auto"
  >
    <v-expand-transition>
      <div
        v-if="pesticides"
        class="d-flex transition-fast-in-fast-out primary darken-1 v-card--reveal"
      >
        <v-card-text class="secondary--text text--lighten-1 text-justify">
          <v-row>
            <v-col cols="6">
              <v-icon
                large
                color="secondary lighten-1"
                @click="togglePesticides"
                >mdi-arrow-left-circle</v-icon
              >
            </v-col>
            <v-spacer />
            <v-col cols="6" align-self="end" align="end">
              <v-icon large color="secondary lighten-1">$toxic</v-icon>
            </v-col>
          </v-row>
          <br />
          {{ pesticidesText }}
        </v-card-text>
      </div>
    </v-expand-transition>
    <div v-if="!pesticides">
      <v-card-subtitle class="white--text text--white">
        <span class="textDate"
          ><v-icon small>restore</v-icon> atualizado em</span
        ><br />
        <span class="textDate" v-if="indicator">{{
          indicator.params.data_dado
        }}</span>
        <span class="textDate" v-else>dd/mm/aaaa</span>
      </v-card-subtitle>
      <v-card-title>
        <v-icon class="ml-n1" color="secondary lighten-1" large>
          $toxic
        </v-icon>
      </v-card-title>
      <v-card-subtitle class="white--text text--white">
        <strong class="textTitle">Agrotóxicos</strong>
        <v-tooltip right color="#1A232F">
          <template v-slot:activator="{on, attrs}">
            <v-icon
              class="ml-1"
              color="secondary lighten-1"
              v-bind="attrs"
              v-on="on"
              @click="togglePesticides"
            >
              help_outline
            </v-icon>
          </template>
          <span>Clique para informações</span>
        </v-tooltip>
      </v-card-subtitle>
      <v-card-text class="white--text text--white">
        <v-row dense>
          <v-col cols="6">
            <span class="textItem">Pastagens</span>
          </v-col>
          <v-col cols="6">
            <strong class="textItemValue">{{
              location && toxic && toxic.indagrotoxico
                ? normalizeValue(toxic.indagrotoxico.PASTAGEM_ton)
                : fixValue(indicator.vals.Pastagem)
            }}</strong
            ><span class="textItemSuffix">{{
              location ? ' kg/ano' : ' ton/ano'
            }}</span>
          </v-col>
          <v-col cols="6">
            <span class="textItem">Agricultura</span>
          </v-col>
          <v-col cols="6">
            <strong class="textItemValue">{{
              location && toxic && toxic.indagrotoxico
                ? normalizeValue(toxic.indagrotoxico.AGRIC_ANUAL_ton)
                : mapValue(indicator.vals)
            }}</strong
            ><span class="textItemSuffix">{{
              location ? ' kg/ano' : ' ton/ano'
            }}</span>
          </v-col>
          <v-col cols="6">
            <span class="textItem">Silvicultura</span>
          </v-col>
          <v-col cols="6">
            <strong class="textItemValue">{{
              location && toxic && toxic.indagrotoxico
                ? normalizeValue(toxic.indagrotoxico.SILVICULTURA_ton)
                : fixValue(indicator.vals.Silvicultura)
            }}</strong
            ><span class="textItemSuffix">{{
              location ? ' kg/ano' : ' ton/ano'
            }}</span>
          </v-col>
        </v-row>
      </v-card-text>
    </div>
  </v-card>
</template>

<script>
export default {
  name: 'CardPesticides',
  props: {
    minWidth: {
      required: false,
    },
    width: {
      required: false,
    },
    location: {
      required: true,
    },
    indicator: {
      required: true,
    },
    toxic: {
      required: true,
    },
  },
  data() {
    return {
      key: 'Agricultura Anual',
      pesticides: false,
      pesticidesText:
        'Os dados e informações sobre agrotóxicos se referem ao volume de agrotóxicos comercializados no estado do Paraná (ADAPAR, 2019). Inicialmente, estes dados estavam organizados por municípios e por tipo de culturas. Para a desagregação desses dados de municípios e compilação para a unidade de análise de bacias hidrográficas, foi realizada a ponderação dos volumes comercializados por tipo de cultura em cada manancial em função da porcentagem das respectivas áreas de agricultura, pastagem e silvicultura de cada município em cada manancial.',
    };
  },
  methods: {
    togglePesticides() {
      this.pesticides = !this.pesticides;
    },
    mapValue(indicator) {
      for (const item in indicator) {
        if (item.includes('Anual')) {
          return indicator[item].toLocaleString('pt-BR', {
            minimumFractionDigits: 1,
            maximumFractionDigits: 1,
          });
        }
      }
    },
    normalizeValue(value) {
      return (value * 1000).toLocaleString('pt-BR', {
        minimumFractionDigits: 1,
        maximumFractionDigits: 1,
      });
    },
    fixValue(value) {
      return value.toLocaleString('pt-BR', {
        minimumFractionDigits: 1,
        maximumFractionDigits: 1,
      });
    },
  },
};
</script>

<style scoped>
.textDate {
  font-family: Roboto;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: 0em;
}
.textTitle {
  font-family: Roboto;
  font-size: 16px;
  font-weight: 700;
  line-height: 20px;
  letter-spacing: 0em;
}
.textItem {
  font-family: Roboto;
  font-size: 16px;
  font-weight: 400;
}
.textItemValue {
  font-family: Roboto;
  font-size: 16px;
  font-weight: 700;
}
.textItemSuffix {
  font-family: Roboto;
  font-size: 16px;
  font-weight: 400;
}
/* width */
::-webkit-scrollbar {
  width: 7px;
}
/* Track */
::-webkit-scrollbar-track {
  background: #f1f1f1;
}
/* Handle */
::-webkit-scrollbar-thumb {
  background: darkgrey;
}
/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: grey;
}
</style>
